import React from 'react';
import Header from './Header';
import HeroSlider from './HeroSlider';
import Services from './Services';
import WhyUs from './WhyUs';
import GallerySlider from './GallerySlider';
import Contact from './Contact';
import Footer from './Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSlider />
      <Services />
      <WhyUs />
      <GallerySlider />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
